package com.example.readingnotes.domain.model

/**
 * Stripe Connect account status
 */
data class StripeConnectStatus(
    val connected: Boolean,
    val chargesEnabled: Boolean,
    val payoutsEnabled: Boolean,
    val onboardingCompleted: Boolean,
    val detailsSubmitted: Boolean,
    val country: String? = null,
    val stripeAccountId: String? = null,
)

/**
 * Onboarding link for Stripe Connect
 */
data class OnboardingLink(
    val url: String,
    val stripeAccountId: String? = null,
)

/**
 * OAuth callback result
 */
data class StripeConnectCallbackResult(
    val success: Boolean,
    val accountId: String? = null,
    val onboardingCompleted: Boolean? = null,
    val status: StripeConnectStatus? = null,
)
